export enum TableNames {
  HtmlTemplate = 'HtmlTemplate',
  KeyValueStore = 'KeyValueStore',
  HtmlStorage = 'HtmlStorage'
}
